<app-item-content [instructionItemContentTemplate]="itemContentCustomInstructionBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel"></app-item-content>
<ng-template #itemContentCustomInstructionBoxes let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps) {
		@if (instruction.volume) { <app-instruction-box>{{ instruction.volume.quantity }} {{ instruction.volume.unit }}</app-instruction-box>  }
		@if (instruction.medicationRoute !== null) { <app-instruction-box>{{ instruction.medicationRoute | medicationRouteName }}</app-instruction-box>  }
	}
</ng-template>